export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: `${window.location.origin}/auth/callback`,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  },
  useRefreshTokens: true,
  cacheLocation: "localstorage" as const,
};
